import { Box, Button, ButtonGroup, Heading, useToast } from "@chakra-ui/react";
import { convert, stringToCode } from "encoding-japanese";
import { useEffect, useMemo, useState } from "react";
import { RequestPolicy } from "urql";
import { useExportCsvQuery } from "./index.generated";

export const ExportCsvButton = ({
  courseId,
  courseName,
}: {
  courseId: string;
  courseName: string;
}) => {
  const toast = useToast();

  const [textCode, setTextCode] = useState<"SJIS" | "UTF8" | "">("");

  const queryContext = useMemo(
    () => ({ requestPolicy: "network-only" as RequestPolicy }),
    []
  );
  const [exportCsvTextQueryRes, exportCsvTextQuery] = useExportCsvQuery({
    variables: {
      courseId: courseId,
    },
    pause: true,
    context: queryContext,
  });

  const csvText = exportCsvTextQueryRes.data?.exportCsv.exportValue!.csvText;

  useEffect(() => {
    if (!csvText) return;
    let encodedText: number[];
    switch (textCode) {
      case "SJIS":
        encodedText = convert(stringToCode(csvText), "SJIS", "UNICODE");
        break;
      case "UTF8":
        encodedText = convert(stringToCode(csvText), "UTF8", "UNICODE");
        break;
      case "":
        return;
    }
    const blob = new Blob([new Uint8Array(encodedText)], {
      type: "text/csv",
    });
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    const nowTime = new Date();
    const y = nowTime.getFullYear();
    const m = ("00" + (nowTime.getMonth() + 1)).slice(-2);
    const d = ("00" + nowTime.getDate()).slice(-2);
    const h = ("00" + nowTime.getHours()).slice(-2);
    const min = ("00" + nowTime.getMinutes()).slice(-2);
    const s = ("00" + nowTime.getSeconds()).slice(-2);
    const nowTimeStr = `${y}-${m}-${d}-${h}-${min}-${s}`;
    anchor.download = `${courseName}_${nowTimeStr}.csv`;
    document.body.appendChild(anchor);
    anchor.click();
    URL.revokeObjectURL(anchor.href);
    document.body.removeChild(anchor);
    setTextCode("");
  }, [csvText, textCode]);

  return (
    <Box my={6}>
      <Heading mb={2} size="md">
        CSVエクスポート
      </Heading>
      <ButtonGroup>
        <Button
          aria-label="export-utf8"
          size="sm"
          variant="outline"
          onClick={() => {
            toast({
              title: "csv作成開始",
              description: "csvの作成を開始します。しばらくお待ちください。",
              status: "loading",
              duration: 2000,
              isClosable: true,
            });
            setTextCode("UTF8");
            exportCsvTextQuery();
          }}
        >
          UTF8
        </Button>
        <Button
          aria-label="export-utf8"
          size="sm"
          variant="outline"
          onClick={() => {
            toast({
              title: "csv作成開始",
              description: "csvの作成を開始します。しばらくお待ちください。",
              status: "loading",
              duration: 2000,
              isClosable: true,
            });
            setTextCode("SJIS");
            exportCsvTextQuery();
          }}
        >
          Shift_JIS
        </Button>
      </ButtonGroup>
    </Box>
  );
};
